<template>
  <b-modal v-model="visible" centered title="Zakładki przestrzenne" :ok-only="true" ok-title="Zamknij" @hidden="hidden">
    <b-row>
      <b-col>
        <b-alert :show="errorsOccured" variant="danger">
          <span>
            <strong>Uwaga.</strong> Formularz zawiera błędy.
          </span>
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form @submit.prevent="postSpatialTab">
          <b-form-row v-if="dataErrors.titleEmpty">
            <b-col offset="3">
              <small class="text-danger">Należy wpisać nazwę zakładki przestrzennej.</small>
            </b-col>
          </b-form-row>
          <b-form-row v-if="dataErrors.titleTooLong">
            <b-col offset="3">
              <small class="text-danger">Nazwa zakładki przestrzennej może mieć maksymalnie 255 znaków.</small>
            </b-col>
          </b-form-row>
          <b-form-group id="nameLabel" :label-cols="3" label="Nazwa" label-for="name">
            <b-form-input id="name" v-model="name" :state="errorsOccured ? false : null" placeholder="Wpisz nazwę"></b-form-input>
          </b-form-group>
          <div class="float-right">
            <b-button type="submit" variant="primary">Zapisz</b-button>
            <b-button variant="outline-secondary" @click.prevent="cancel">Anuluj</b-button>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5>Zakładki przestrzenne</h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table id="spatialTabsTable" show-empty striped bordered :fields="fields" :items="$store.getters.spatialTabs" empty-text="Nie dodano zakładek przestrzennych.">
          <template v-slot:cell(actions)="data">
            <a href="#" title="Przejdź" @click.prevent="goto(data.item)">
              <span class="oi oi-magnifying-glass"></span>
            </a>
            <a href="#" title="Edytuj" @click.prevent="edit(data.item)">
              <span class="oi oi-pencil"></span>
            </a>
            <a href="#" title="Usuń" @click.prevent="deleteTab(data.item)">
              <span class="oi oi-trash"></span>
            </a>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <loading-overlay :active="$store.getters.spatialTabsLoading" :is-full-page="false"></loading-overlay>
  </b-modal>
</template>

<script>
import { SPATIAL_TABS_MODAL_HIDDEN } from '../store/mutations.type';
import { SPATIAL_TABS_POST_TAB, SPATIAL_TABS_DELETE, SPATIAL_TABS_PUT_TAB, SPATIAL_TABS_GOTO } from '../store/actions.type';
import LoadingOverlay from 'vue-loading-overlay';

export default {
  components: {
    LoadingOverlay
  },
  data() {
    return {
      name: null,
      fields: [
        { 
          key: "nazwa", 
          label: "Nazwa" 
        }, 
        { 
          key: "actions", 
          label: "", 
          tdClass: "fit-to-content" 
        }
      ],
      errorsOccured: false,
      dataErrors: {
        titleEmpty: false,
        titleTooLong: false
      },
      editedTab: null
    };
  },
  computed: {
    visible: {
      get() { return this.$store.getters.spatialTabsModalVisible; },
      set(v) { if (!v) this.$store.commit(SPATIAL_TABS_MODAL_HIDDEN); }
    },
  },
  methods: {
    validate() {
      this.cleanErrors();
      if (!this.name) {
        this.dataErrors.titleEmpty = true;
      } else if (this.name.length > 255) {
        this.dataErrors.titleTooLong = true;
      }
      var self = this;
      return Object.keys(this.dataErrors).some(
        x => self.dataErrors[x] === true
      );
    },
    cleanErrors() {
      var self = this;
      Object.keys(this.dataErrors).forEach(x => (self.dataErrors[x] = false));
      this.errorsOccured = false;
    },
    async postSpatialTab() {
      this.errorsOccured = this.validate();
      if (!this.errorsOccured) {
        const success = 
        this.editedTab
          ? this.$store.dispatch(SPATIAL_TABS_PUT_TAB, { name: this.name, tab: this.editedTab })
          : this.$store.dispatch(SPATIAL_TABS_POST_TAB, this.name);
      }
    },
    async deleteTab(tab) {
      if (tab == this.editedTab) {
        this.name = null;
        this.editedTab = null;
      }

      await this.$store.dispatch(SPATIAL_TABS_DELETE, tab);
    },
    edit(tab) {
      this.cleanErrors();
      this.editedTab = tab;
      this.name = this.editedTab.nazwa;
    },
    goto(tab) {
      this.$store.dispatch(SPATIAL_TABS_GOTO, tab);
    },
    cancel() {
      this.name = null;
      this.editedTab = null;
    },
    hidden() { 
      this.cleanErrors();
      this.name = null;
      this.editedTab = null;
      this.visible = false;
    }
  }
}
</script>

<style>
.fit-to-content {
  width: 1%;
  white-space: nowrap;
}

#spatialTabsTable > tbody > tr > td {
  word-break: break-all;
}
</style>